import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/banners";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = banners.length;

  const next = useCallback(() => setIndex((i) => (i + 1) % total), [total]);
  const prev = () => setIndex((i) => (i - 1 + total) % total);

  useEffect(() => {
    const timer = setInterval(next, 5500);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[440px] md:h-[560px] overflow-hidden bg-foreground-950">
      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={banner.image}
            alt={`${banner.title} 焦点推荐`}
            title={`${banner.title} - 动漫全集`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
        </div>
      ))}

      <div className="relative z-10 h-full mx-auto max-w-[1280px] px-4 md:px-8 flex flex-col justify-center">
        <div key={index} className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
            <i className="ri-fire-fill" />
            {banners[index].tag}
          </span>
          <h2 className="font-heading font-extrabold text-3xl md:text-5xl text-background-50 mt-4 leading-tight">
            {banners[index].title}
          </h2>
          <p className="text-background-100/90 text-sm md:text-base mt-3 md:mt-4 max-w-lg">
            {banners[index].subtitle}
          </p>
          <div className="flex items-center gap-3 mt-6 md:mt-8">
            <Link
              to={`/detail/${banners[index].animeId}`}
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" />
              立即查看
            </Link>
            <Link
              to="/category/hot-blood"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/15 border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-colors backdrop-blur-sm whitespace-nowrap"
            >
              浏览分类
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute z-20 bottom-5 right-4 md:right-8 flex items-center gap-3">
        <button
          onClick={prev}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 border border-background-50/40 text-background-50 hover:bg-background-50/35 transition-colors backdrop-blur-sm cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-lg" />
        </button>
        <button
          onClick={next}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 border border-background-50/40 text-background-50 hover:bg-background-50/35 transition-colors backdrop-blur-sm cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-lg" />
        </button>
      </div>

      <div className="absolute z-20 bottom-6 left-4 md:left-8 flex items-center gap-2">
        {banners.map((banner, i) => (
          <button
            key={banner.id}
            onClick={() => setIndex(i)}
            aria-label={`切换到 ${banner.title}`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-7 bg-primary-500" : "w-3 bg-background-50/50 hover:bg-background-50/80"
            }`}
          />
        ))}
      </div>
    </section>
  );
}